import { Observable } from 'rxjs';

import { DeleteJobSiteOptions, Job, JobSite, JobSiteCreationData, JobSiteReferenceData } from '@mirage-projects/cw-models';

export interface SnapshotTypeOption {
    label: string;
    value: string;
}

/**
 * Abstract service definition to manage the job site endpoints
 */
export abstract class JobSiteService {
    abstract get(id: number): Observable<JobSite>;

    /**
     * Observable that allows us to know when a jobsite has been modified.
     */
    abstract updateJobSite$: Observable<JobSite>;

    /**
     * Add project to a job site
     * @param jobSiteId Job site id
     * @param projectId Project id
     */
    abstract addProject(jobSiteId: number, projectId: number): Observable<JobSite>;

    /**
     * Add layer to a job site
     * @param jobSiteId Job site id
     * @param layer layer
     */
    abstract addReferenceData(jobSiteId: number, layer: JobSiteReferenceData): Observable<JobSite>;

    /**
     * Update job site information
     * @param jobSiteId Site id to update
     * @param jobSiteData Job site data
     */
    abstract updateJobSite(jobSiteId: number, jobSiteData: Partial<JobSite>): Observable<JobSite>;

    /**
     * Get job site information
     * @param jobSiteId Site id to get
     */
    abstract snapshotTypeOptions(): SnapshotTypeOption[];

    /**
     * Remove a specific project from a site
     * @param jobSiteId Job site id
     * @param projectId Project id
     */
    abstract removeProject(jobSiteId: number, projectId: number): Observable<void>;

    /**
     * Creates a new site
     * @param jobSiteData The specific data to create the site
     */
    abstract createJobSite(jobSiteData: JobSiteCreationData): Observable<JobSite>;

    abstract getJobsFromJobSite(id: number): Observable<Job[]>;

    /**
     * Delete a job site
     * @param jobSiteId Job site id
     * @param options Delete options
     */
    abstract deleteJobSite(jobSiteId: number, options: DeleteJobSiteOptions): Observable<void>;

    abstract dettachProjects(jobSiteId: number, projectsIdsList: number[]): Observable<void>;
}
